export { default as Tick } from './tick.svg'
